import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import 'animate.css';
import { WOW } from 'wowjs';

import '@/assets/css/normalize.css';

import "@/libs/element-ui-plugin";
import "@/assets/scss/element-variables.scss";

import '@/assets/scss/common.scss';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 全局配置 Wow.js
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 需要执行动画的元素的 class
  animateClass: 'animate__animated', // animation.css 动画的 class
  offset: 0, // 距离可视区域多少开始执行动画
  mobile: true, // 是否在移动设备上执行动画
  live: false, // 异步加载的内容是否有效
});

Vue.prototype.$wow.init();
